import { RefreshIcon, StarIcon, TrashIcon, XIcon } from "@heroicons/react/outline";

const BulkActionBar = ({
  count,
  filteredTotal,
  allFav,
  progress,
  onSelectAllFiltered,
  onFav,
  onRecheck,
  onDelete,
  onClear,
}) => {
  const busy = Boolean(progress);
  return (
    <div className="ds-bulkbar" role="region" aria-label="Μαζικές ενέργειες">
      <span className="ds-bulkbar-count">
        Επιλέχθηκαν <strong>{count}</strong>
      </span>
      {count < filteredTotal && (
        <button type="button" className="ds-link-btn" onClick={onSelectAllFiltered} disabled={busy}>
          Επιλογή όλων των {filteredTotal}
        </button>
      )}
      <div className="ds-toolbar-spacer" />
      {progress ? (
        <span className="ds-bulkbar-progress" aria-live="polite">
          {progress.label} {progress.done}/{progress.total}…
        </span>
      ) : (
        <>
          <button type="button" className="ds-btn" onClick={onFav}>
            <StarIcon aria-hidden="true" />
            {allFav ? "Αφαίρεση από σημαντικά" : "Σημαντικά"}
          </button>
          <button type="button" className="ds-btn" onClick={onRecheck}>
            <RefreshIcon aria-hidden="true" />
            Έλεγχος
          </button>
          <button type="button" className="ds-btn ds-btn--danger" onClick={onDelete}>
            <TrashIcon aria-hidden="true" />
            Διαγραφή
          </button>
        </>
      )}
      <button
        type="button"
        className="ds-icon-btn"
        onClick={onClear}
        disabled={busy}
        aria-label="Καθαρισμός επιλογής"
        title="Καθαρισμός επιλογής"
      >
        <XIcon aria-hidden="true" />
      </button>
    </div>
  );
};

export default BulkActionBar;
